/**
 * 命令式 API:createCustomerService
 *
 * 客服为 fixed 浮层(无页面位置),直接挂载 widget 到 body,无需容器元素。
 * 自动挂载默认开启;此 API 用于定制样式或显式控制生命周期。
 *
 * 与自动挂载互斥:mountCustomerService 单例,命令式调用会接管
 * (自动挂载检测 currentHandle 跳过);多次调用亦只保留最后一个实例。
 */
import { mountCustomerService } from './widget';
import type { CreateCustomerServiceOptions, CustomerServiceHandle } from '../types';

export function createCustomerService(opts: CreateCustomerServiceOptions): CustomerServiceHandle {
  return mountCustomerService(opts);
}
